export const fillInformation = (state, action)=>{ 
    //UseReducer -> um useState  porém com inumeras variaveis e funções, no caso esse para 
    //cadastro de produtos
    switch(action.type){
        case "codigosForn":
            return {
                ...state,
                codigosForn: action.value
            };
        case "codFornSelecionado":
            return {
                ...state,
                codFornSelecionado: action.value
            };
        case "produtosForn":
            return {
                ...state,
                produtosForn: action.value
            };
        case "produtosSelecionados":
            return {
                ...state,
                produtosSelecionados: action.value
            };
            case 'ALTERAR_QTDE': {
                const { chaveItem, chaveTam, delta, limite, itemConfigurado } = action.payload;
            
                const itemAtual = state.produtosSelecionados[chaveItem] || {
                    fabricante: itemConfigurado.fabricante,
                    item: itemConfigurado.item,
                    loja: itemConfigurado.loj_num,
                    tamanhos: {}
                };
            
                const atual = itemAtual.tamanhos[chaveTam] || 0;
            
                let novaQtde = atual + delta;
                if (novaQtde < 0) novaQtde = 0;
                if (novaQtde > limite) novaQtde = limite;
            
                // 🔥 copia tamanhos
                const novosTamanhos = {
                    ...itemAtual.tamanhos
                };
            
                if (novaQtde === 0) {
                    delete novosTamanhos[chaveTam];
                } else {
                    novosTamanhos[chaveTam] = novaQtde;
                }
            
                // 🔥 verifica se ainda tem algum tamanho
                const aindaTemTamanhos = Object.keys(novosTamanhos).length > 0;
            
                const novosProdutosSelecionados = {
                    ...state.produtosSelecionados
                };
            
                if (!aindaTemTamanhos) {
                    // 🚀 remove o item inteiro
                    delete novosProdutosSelecionados[chaveItem];
                } else {
                    novosProdutosSelecionados[chaveItem] = {
                        ...itemAtual,
                        tamanhos: novosTamanhos
                    };
                }
            
                return {
                    ...state,
                    produtosSelecionados: novosProdutosSelecionados
                };
            }
        default:
            return {
                ...state
            };
        }
}